import { americanToDecimal } from "@/utils/calculators/odds-utils";

export const YOUTUBE_PRICE_FIRST = {
  videoId: "QNFW9Ze-3y0",
  title: "Matt’s three-step price-first betting process",
  slug: "price-first",
  path: "/learning-center/watch/price-first",
  flag: "youtube_price_first_walkthrough_v1",
  exposure: "youtube_walkthrough_experiment_entered",
  version: "price_first_walkthrough_v1",
  tool: "/optimizer?sportsbook=novig",
} as const;

export const PRICE_FIRST_MARKET = {
  id: "practice-oregon-usc-under-58-5",
  game: "Oregon at USC",
  outcome: "Under 58.5 points",
  fair: .423,
  books: [
    { id: "novig", name: "Novig", odds: 147 },
    { id: "kalshi", name: "Kalshi", odds: 140 },
    { id: "prophetx", name: "ProphetX", odds: 125 },
    { id: "fanduel", name: "FanDuel", odds: 120 },
    { id: "draftkings", name: "DraftKings", odds: 115 },
  ],
} as const;

export const PRICE_FIRST_LESSONS = [
  { label: "Check the offers", title: "Start with the options available to you.", chapter: 40, instruction: "Matt starts by checking platforms and welcome offers. Read the terms first: advertised bonus credit is not cash profit." },
  { label: "Find the better price", title: "Same game. Same under. Different return.", chapter: 175, instruction: "The video compares Oregon–USC under 58.5. Upside puts the prices side by side, so you can buy the same outcome at a better price." },
  { label: "Keep the stake small", title: "A good price still needs a sensible stake.", chapter: 735, instruction: "Try Matt’s illustrative 1% rule: a $1,000 bankroll gives a $10 stake. Review the example, then confirm the practice bet." },
] as const;

export function priceFirstOrder(bankroll: number, stake: number, odds: number) {
  const cents = (value: number) => Number.isFinite(value) && value > 0 && Number.isSafeInteger(Math.round(value * 100)) && Math.abs(value * 100 - Math.round(value * 100)) < .000001;
  if (!cents(bankroll) || !cents(stake) || !Number.isFinite(odds) || Math.abs(odds) < 100) return null;
  const decimal = americanToDecimal(odds);
  const unit = Math.floor(Math.round(bankroll * 100) / 100) / 100;
  const profit = Math.round(stake * (decimal - 1) * 100) / 100;
  const ev = (PRICE_FIRST_MARKET.fair * decimal - 1) * 100;
  return { bankroll, stake, unit, odds, implied: 100 / decimal, ev, profit, payout: Math.round((stake + profit) * 100) / 100, expectedProfit: stake * ev / 100, canPlace: stake <= unit && ev > 0 };
}
